import React, { useId } from "react";
import type { DropdownProps } from "semantic-ui-react";
import { Dropdown as SemanticDropdown } from "semantic-ui-react";
import { ExportType } from "src/types/enums/ExportRequest";
import styled from "styled-components";

interface ExportDropdownProps {
  handleExport: (exportType: ExportType) => void;
  exportOptions: Array<{
    key: string;
    text: string;
    value: ExportType;
  }>;
}

const ExportDropdown: React.FC<ExportDropdownProps> = ({
  handleExport,
  exportOptions,
}) => {
  const searchInputId = useId().replace(/:/g, '');
  const onExport = (exportType: ExportType): void => {
    handleExport(exportType);
  };

  return (
    <StyledDropdown
      button
      className="ui button"
      search
      searchInput={{ id: `export-type-dropdown-${searchInputId}`, 'aria-label': 'Export options' }}
      options={exportOptions.map((o) => ({ ...o, value: o.value }))}
      onChange={(
        _e: React.SyntheticEvent<HTMLElement, Event>,
        data: DropdownProps,
      ) => {
        onExport(data.value as ExportType);
      }}
      text="Export"
    />
  );
};
const StyledDropdown = styled(SemanticDropdown)`
  background-color: rgb(0, 181, 225) !important;
  color: white !important;
  font-weight: 600 !important;
`;

export default ExportDropdown;
